import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from '@totvs/mingle/node_modules/rxjs';
import { tap, catchError } from '@totvs/mingle/node_modules/rxjs/operators';
import { get } from 'lodash-es';
import { HttpService } from 'src/app/core/http/http.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  checkLoaded: Subject<any> = new Subject<any>();
  config: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isLoaded: boolean = false;

  constructor(private http: HttpService) {}

  

}
